<template>
    <!-- card-title="1: Archivos FTP" -->
    <!-- :card-data="data" -->
  <card-template
    :card-title="data.cardName"
    :is-loading="isLoading"
    :card-info="getCardInfo()"
    card-type="FTP"
  ></card-template>
</template>

<script>
import CardTemplate from './card-template.vue'
import supervisorStorage from '../../storage/supervisorStorage'
export default {
  name: 'card-ftp-files',
  methods: {
    getCardInfo () {
      const outdated = supervisorStorage.getOutDatedFtpFiles()
      const updated = supervisorStorage.getUpdatedFtpFiles()
      const total = updated + outdated

      const percentageUpdated = updated / total
      // const percentageOutDated = outdated / total
      if (this.isLoading) {
        return {
          lightColor: 'gray',
          cardNumber: outdated,
          message: 'Verificando archivos'
        }
      }
      if (total === updated) {
        return {
          lightColor: 'green',
          cardNumber: 0,
          message: 'Todos los distribuidora(s) enviaron sus archivos'
        }
      }
      if (percentageUpdated > 0.9) {
        return {
          lightColor: 'amber',
          cardNumber: outdated,
          message: `de ${total} distribuidora(s) no ha(n) enviado sus archivos`
        }
      }
      return {
        lightColor: 'red',
        cardNumber: outdated,
        message: `de ${total} distribuidora(s) no ha(n) enviado sus archivos`
      }
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      default () {
        return true
      }
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    CardTemplate
  }
}
</script>



// WEBPACK FOOTER //
// src/components/supervisor/card-ftp-files.vue